import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import DashBoardLayout from "./dashboard/DashboardLayout";
import LoginForm from "./login/LoginForm";
import Dashboard from "./dashboard/Dashboard";
import OwnerDashboard from "./dashboard/OwnerDashboard";
import Category from "./cateogory/Category";
import CreateRoom from "./createRoom/CreateRoom";
import BookRoom from "./bookroom/BookRoom";
import BookBanquet from "./bookroom/BookBanquet";
import CreateBill from "./createBill/CreateBill";
import ShowBills from "./createBill/ShowBills";
import Customer from "./customer/Customer";
import { CreateBanquetBill } from "./createBanquetBill/CreateBanquetBill";
import CustomerBillSection from "./createBill/CustomerBillSection";
import { Configuration } from "./configuration/Configuration";
import { Employee } from "./employee/Employee";
import { Accounting } from "./accounting/Accounting";
import ProfilePage from "./profile/ProfilePage";
import { RechargePortal } from "./rechargePortal/RechargePortal";
import ReportManagement from "./report/ReportManagement";
function AppRoutes() {


  return (
    <Routes>
      <Route path="/login" element={<LoginForm />} />
      <Route exact path="/customer-bill-section" element={<CustomerBillSection />} />
      <Route element={<DashBoardLayout />}>
        <Route path="/accounting" element={<Accounting />} />
        <Route path="/bookbanquet" element={<BookBanquet />} />
        <Route path="/bookroom" element={<BookRoom />} />
        <Route path="/cateogory" element={<Category />} />
        <Route path="/createBanquetBill" element={<CreateBanquetBill />} />
        <Route path="/createBill" element={<CreateBill />} />
        <Route path="/createroom" element={<CreateRoom />} />
        <Route path="/config" element={<Configuration />} />
        <Route path="/customer" element={<Customer />} />
        <Route path="/dashboard" element={<OwnerDashboard />} />
        <Route path="/employee" element={<Employee />} />
        <Route path="/home" element={<Dashboard />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/recharge" element={<RechargePortal />} />
        <Route path="/showbookings" element={<ShowBills />} />
        <Route path="/report" element={<ReportManagement />} />
      </Route>
      <Route exact path="/" element={<Navigate replace to="/login" />} />
    </Routes>
  );
}

export default AppRoutes;
